// moved from lut
export const calculateFormCompleteness = (el: IObjectAny, fields: string[]) => {
  let completedCount = 0
  fields.forEach((field) => {
    if (el[field]) {
      completedCount++
    }
  })

  return Number(((completedCount / fields.length) * 100).toFixed(2))
}
